import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../../candidature-formation.model';
import {FormationService, Question} from '../../../formation';
import {Composant, Discipline, GrhumService} from '../../../grhum';
import {Parametrage, ParametrageService} from '../../../parametrage';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../../cadens.constants';
import {JhiLanguageService} from 'ng-jhipster';
import {FormationComponentService} from '../formationComponent.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'jhi-diplome-component',
    templateUrl: 'diplome.component.html'
})
export class DiplomeComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() isEditable: Boolean;
    @Input() questions: Question[];
    @Input() isBO: number;
    @Output() btnActivation = new EventEmitter();

    parametrage: any;
    departement: string;
    currentLang: string;
    annee: number;
    disciplinesListe: Discipline[];
    disciplinesParcoursListe: Discipline[];
    parcoursListe: Composant[];
    niveauxListe: Composant[];
    aide: Parametrage;
    isSaving: any;

    constructor(private parametrageService: ParametrageService,
                private grhumService: GrhumService,
                private jhiLanguageService: JhiLanguageService,
                private formationService: FormationService,
                private modalService: NgbModal,
                private formationComponentService: FormationComponentService
                ) {
        this.currentLang = '' + this.jhiLanguageService.currentLang;
    }

    ngOnInit() {
        this.parametrageService.query({page: CONSTANTS.DIPLOME}).subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.niveauxListe = [];
        this.parcoursListe = [];
        if (this.candidatureFormation.parcoursId) {
            this.annee = 2;
            this.getListeParcours(this.candidatureFormation.disciplineId);
            this.getListeNiveaux(this.candidatureFormation.parcoursId);
        } else if (this.candidatureFormation.disciplineId) {
            if (this.candidatureFormation.ects === 180) {
                this.annee = 1;
            }
            this.getListeStructure(this.candidatureFormation.disciplineId);
        }
        this.getListeDisciplines();
    }

    onChangeEcts(newEcts) {
        this.annee = null;
        this.cleanInfos();
    }

    onChangeParcours(newParcours) {
        // Appelé à chaque fois que la mention change: recharger la liste des niveaux
        this.getListeNiveaux(newParcours);
    }

    onChangeAnnee(newAnnee) {
        this.cleanInfos();
    }

    onChangeDiscipline(newDiscipline) {
        this.candidatureFormation.disciplineId = newDiscipline;
        if (this.annee === 2) {
            this.getListeParcours(newDiscipline);
            this.candidatureFormation.parcoursId = null;
            this.candidatureFormation.niveauId = null;
        } else {
            // select le département de la discipline
            this.getListeStructure(newDiscipline);
            // Get la formation correspondant à la discipline
            this.isSaving = true;
            this.formationService.query({disciplineId: newDiscipline}).subscribe(
                (res: Response) => {
                    let formation = res.json();
                    formation = formation.filter(forma => forma.id != CONSTANTS.DOUBLE_CURSUS_ID && forma.id != CONSTANTS.PROGRAMME_EM_LYON_ID) ;
                    this.candidatureFormation.formationId = formation[0].id;
                    this.candidatureFormation.libelle = formation[0].libelle;
                    this.formationComponentService.changeFormation(this.candidatureFormation.formationId);
                    this.isSaving = false;
                }, (res: Response) => {
                    this.isSaving = false;
                });
            this.niveauxListe = [];
            this.parcoursListe = [];
            this.findDisciplineLibelle();
        }
    }

    findFormation(newNiveau) {
        this.isSaving = true;
        this.formationService.query({
            disciplineId: this.candidatureFormation.disciplineId,
            parcoursId: this.candidatureFormation.parcoursId, niveauId: newNiveau
        }).subscribe(
            (res: Response) => {
                let formation = res.json();
                formation = formation.filter(forma => forma.id != CONSTANTS.DOUBLE_CURSUS_ID && forma.id != CONSTANTS.PROGRAMME_EM_LYON_ID) ;
                this.candidatureFormation.formationId = formation[0].id;
                this.candidatureFormation.libelle = formation[0].libelle;
                this.formationComponentService.changeFormation(this.candidatureFormation.formationId);
                this.isSaving = false;
            }, (res: Response) => {
                this.isSaving = false;
            });
    }

    // Open la popup d'aide
    openAide(aideModal, parametre) {
        this.aide = parametre;
        this.modalService.open(aideModal);
    }

    private getListeDisciplines() {
        if (!this.disciplinesListe) {
            this.formationService.queryDisciplinesFormations({
                niveau: 1, reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            })
                .subscribe((res: Response) => {
                    this.disciplinesListe = res.json();
                    this.findDisciplineLibelle();
                });
        }
        if (!this.disciplinesParcoursListe) {
            this.formationService.queryDisciplinesFormations({
                niveau: 2, reinscription: this.candidatureFormation.reinscription,
                lecture: (this.isBO > 0 || !this.isEditable)
            })
                .subscribe((res: Response) => {
                    this.disciplinesParcoursListe = res.json();
                });
        }
    }

    private getListeParcours(disciplineId) {
        this.grhumService.queryComposant({
            type: CONSTANTS.PARCOURS, disciplineId: disciplineId,
            reinscription: this.candidatureFormation.reinscription, lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(
            (res: Response) => {
                this.parcoursListe = res.json();
            });
    }

    private getListeNiveaux(parcours) {
        this.grhumService.queryComposant({
            type: CONSTANTS.NIVEAU,
            parentId: parcours,
            disciplineId: this.candidatureFormation.disciplineId,
            reinscription: this.candidatureFormation.reinscription,
            lecture: (this.isBO > 0 || !this.isEditable),
            etudiantId: this.candidatureFormation.userId
        }).subscribe(
            (res: Response) => {
                this.niveauxListe = res.json();
                if (this.niveauxListe != null && this.niveauxListe.length === 1) {
                    this.candidatureFormation.niveauId = this.niveauxListe[0].idComposant;
                    this.findFormation(this.candidatureFormation.niveauId);
                }
            });
    }

    private getListeStructure(disciplineId) {
        this.grhumService.queryStructure({disciplineId: disciplineId}).subscribe(
            (res: Response) => {
                let structures = res.json();
                if (structures && structures.length > 0) {
                    this.departement = structures[0].libelle;
                }
            });
    }

    private cleanInfos() {
        this.niveauxListe = [];
        this.parcoursListe = [];
        this.departement = '';
        this.candidatureFormation.disciplineId = null;
        this.candidatureFormation.discipline = null;
        this.candidatureFormation.parcoursId = null;
        this.candidatureFormation.niveauId = null;
        this.candidatureFormation.formationId = null;
        this.candidatureFormation.libelle = null;
    }

    private findDisciplineLibelle() {
        if (this.disciplinesListe != null && this.candidatureFormation.disciplineId != null) {
            let discipline = this.disciplinesListe.find(d => d.idDiscipline === this.candidatureFormation.disciplineId);
            if (discipline) {
                this.candidatureFormation.discipline = discipline.llDiscipline;
            }
        }
    }

    clickBoutonQuestion(buttonAction: String) {
        this.btnActivation.emit({value: buttonAction}) ;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/formation/diplome/diplome.component.ts